export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';
export const LMS_ACCESS_TOKEN = 'lms_access_token';
